export default __webpack_public_path__ + "static/crusaderLongshanksAccountImg-8bbf182408acf46f3af74c150364daae.png";